import { render, staticRenderFns } from "./itemPatient.vue?vue&type=template&id=a9ac2566&"
import script from "./itemPatient.vue?vue&type=script&lang=js&"
export * from "./itemPatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports